import AppRoutes from "../constants/AppRoutes";
import Logger from "../utils/Logger";
import EventPublisher from "../utils/EventPublisher";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import Optional from "optional-js";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";

class AppNavigationActions {

    constructor() {
        this.history = Optional.empty();
        EventPublisher.subscribe(ActionResultEvents.HISTORY_READY, this.onHistoryReady);
        EventPublisher.subscribe(UIInteractionEvents.PUBLIC_NAV_BRAND_CLICKED, this.navigateToLandingSiteHome);
        EventPublisher.subscribe(UIInteractionEvents.PRIVATE_NAV_BRAND_CLICKED, this.navigateToLandingSiteHome);
        EventPublisher.subscribe(ActionResultEvents.SESSION_CREATED, this.loginRouteNavigateToSpacesSERP);
        EventPublisher.subscribe(UIInteractionEvents.PUBLIC_NAV_LOGIN_BUTTON_CLICKED, this.navigateToLogin);
        EventPublisher.subscribe(UIInteractionEvents.LOGOUT_BUTTON_CLICKED, this.navigateToSpacesSERP);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_DETAILS_BUTTON_CLICKED, this.navigateToSpaceDetails);
        EventPublisher.subscribe(UIInteractionEvents.PRIVATE_NAV_SEARCH_SPACES_CLICKED, this.navigateToSpacesSERP);
        EventPublisher.subscribe(UIInteractionEvents.MY_ADVERTISEMENTS_NEW_ADVERTISEMENT_BUTTON_CLICKED, this.navigateToCreateAdvertisement);
        EventPublisher.subscribe(UIInteractionEvents.MY_ADVERTISEMENTS_BUTTON_CLICK, this.navigateToMyAdvertisements);
        EventPublisher.subscribe(ActionResultEvents.ADVERTISEMENT_CREATED, this.navigateToMyAdvertisements);
        EventPublisher.subscribe(UIInteractionEvents.MY_SPACES_BUTTON_CLICK, this.navigateToMySpaces);
        EventPublisher.subscribe(UIInteractionEvents.MY_SPACES_SPACE_PREVIEW_BUTTON_CLICKED, this.navigateToSpaceDetails);
        EventPublisher.subscribe(UIInteractionEvents.MY_SPACES_EDIT_SPACE_BUTTON_CLICKED, this.navigateToEditSpace);
        EventPublisher.subscribe(UIInteractionEvents.MY_SPACES_MANAGE_SPACE_BUTTON_CLICKED, this.navigateToManageSpace);
        EventPublisher.subscribe(UIInteractionEvents.MY_SPACES_NEW_SPACE_BUTTON_CLICKED, this.navigateToNewSpace);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_PREVIEW_MANAGE_SPACE_BUTTON_CLICKED, this.navigateToManageSpace);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_PREVIEW_EDIT_SPACE_BUTTON_CLICKED, this.navigateToEditSpace);
        EventPublisher.subscribe(UIInteractionEvents.MY_ADVERTISEMENTS_ADVERTISEMENT_PREVIEW_BUTTON_CLICKED, this.navigateToAdvertisement);
        EventPublisher.subscribe(UIInteractionEvents.DONE_WITH_SPACE_CALENDAR_MANAGEMENT_CLICKED, this.navigateToMySpaces);
        EventPublisher.subscribe(ActionResultEvents.SPACE_CREATED, this.navigateToMySpacesUnlistedTab);
        EventPublisher.subscribe(ActionResultEvents.SPACE_EDITED, this.navigateToMySpaces);
        EventPublisher.subscribe(UIInteractionEvents.MY_ADVERTISEMENTS_EDIT_ADVERTISEMENT_BUTTON_CLICKED, this.navigateToEditAdvertisement);
        EventPublisher.subscribe(UIInteractionEvents.PREVIEW_ADVERTISEMENT_EDIT_ADVERTISEMENT_BUTTON_CLICKED, this.navigateToEditAdvertisement);
        EventPublisher.subscribe(ActionResultEvents.ADVERTISEMENT_EDITED, this.navigateToMyAdvertisements);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_RESERVATION_BUTTON_CLICKED, this.navigateToSpaceReservations);
        EventPublisher.subscribe(UIInteractionEvents.RESERVATION_REQUESTS_SPACE_BUTTON_CLICKED, this.navigateToSpaceDetails);
        EventPublisher.subscribe(UIInteractionEvents.ACCEPTED_RESERVATIONS_SPACE_BUTTON_CLICKED, this.navigateToSpaceDetails);
        EventPublisher.subscribe(UIInteractionEvents.HISTORY_SPACE_RESERVATION_SPACE_BUTTON_CLICKED, this.navigateToSpaceDetails);
        EventPublisher.subscribe(UIInteractionEvents.RESERVATION_REQUESTS_ADVERTISEMENT_BUTTON_CLICKED, this.navigateToAdvertisement);
        EventPublisher.subscribe(UIInteractionEvents.ACCEPTED_RESERVATIONS_ADVERTISEMENT_BUTTON_CLICKED, this.navigateToAdvertisement);
        EventPublisher.subscribe(UIInteractionEvents.HISTORY_SPACE_RESERVATION_ADVERTISEMENT_BUTTON_CLICKED, this.navigateToAdvertisement);
        EventPublisher.subscribe(UIInteractionEvents.PRIVATE_SPACE_DETAILS_CREATE_NEW_ADVERTISEMENT_CLICKED, this.navigateToCreateAdvertisement);
        EventPublisher.subscribe(ActionResultEvents.RESERVATION_REQUEST_CREATED_SUCCESSFULLY, this.navigateToAdvertisementReservations);
        EventPublisher.subscribe(UIInteractionEvents.ADVERTISEMENT_OWNER_CONTACT_INFO_BUTTON_CLICKED, this.navigateToAdvertisementOwnerProfile);
        EventPublisher.subscribe(ActionResultEvents.CHECKOUT_PAYMENT_SUCCESS, this.navigateToAdvertisementReservations);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_OWNER_CONTACT_INFO_BUTTON_CLICKED, this.navigateToSpaceOwnerProfile);
        EventPublisher.subscribe(UIInteractionEvents.ADVERTISEMENT_RESERVATION_BUTTON_CLICKED, this.navigateToAdvertisementReservations);
        EventPublisher.subscribe(UIInteractionEvents.PENDING_RESERVATIONS_CHECKOUT_BUTTON_CLICKED, this.navigateToCheckout);
        EventPublisher.subscribe(UIInteractionEvents.CHECKOUT_CANCEL_CLICKED, this.navigateToAdvertisementReservations);
        EventPublisher.subscribe(UIInteractionEvents.EDIT_PROFILE_BUTTON_CLICKED, this.navigateToEditProfile);
        EventPublisher.subscribe(ActionResultEvents.PROFILE_EDITED, this.navigateToSpacesSERP);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_BALANCE_BUTTON_CLICK, this.navigateToBalance);
        EventPublisher.subscribe(UIInteractionEvents.ADVERTISING_BILLING_BUTTON_CLICK, this.navigateToBilling);
        EventPublisher.subscribe(UIInteractionEvents.BACK_CLICKED, this.navigateBackOrToSERP);
    }

    onHistoryReady = (topic, history) => {
        this.history = Optional.of(history);
    };

    navigateToLandingSiteHome = (topic, data) => {
        window.location.replace("https://cuvered.com")
    };

    navigateBackOrToSERP = (topic, data) => {
        this.history.ifPresentOrElse(
            (history) => {
                if (history.length > 1) {
                    history.goBack()
                } else {
                    this.navigateToSpacesSERP(topic, data);
                }
            },
            () => Logger.warn("History not initialized yet.")
        );
    };

    loginRouteNavigateToSpacesSERP = (topic, data) => {
        if (window.location.pathname === AppRoutes.LOGIN) {
            this.navigateToSpacesSERP(topic, data);
        }
    };

    navigateToSpacesSERP = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.SEARCH_SPACES),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToLogin = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.LOGIN),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToMyAdvertisements = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.MY_ADVERTISEMENTS),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToCreateAdvertisement = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.CREATE_ADVERTISEMENT),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToSpaceDetails = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.SPACE_DETAILS.replace(":id", data.spaceId)),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToMySpaces = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.MY_SPACES),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToMySpacesUnlistedTab = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.MY_SPACES + "#unlisted-spaces"),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToEditSpace = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.SPACE_EDIT.replace(":id", data.spaceId)),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToManageSpace = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.SPACE_MANAGE.replace(":id", data.spaceId)),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToNewSpace = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.SPACE_CREATE),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToEditAdvertisement = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.EDIT_ADVERTISEMENT.replace(":id", data.advertisementId)),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToSpaceReservations = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.SPACE_RESERVATIONS),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToAdvertisement = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.ADVERTISEMENT_DETAILS.replace(":id", data.advertisementId)),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToAdvertisementOwnerProfile = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.ADVERTISEMENT_CONTACT_INFO.replace(":id", data.advertisementId)),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToSpaceOwnerProfile = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.SPACE_CONTACT_INFO.replace(":id", data.spaceId)),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToAdvertisementReservations = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.ADVERTISEMENT_RESERVATIONS),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToCheckout = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.CHECKOUT.replace(":id", data.reservationRequestId)),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToEditProfile = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.EDIT_PROFILE),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToBalance = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.SPACE_BALANCES),
            () => Logger.warn("History not initialized yet.")
        );
    };

    navigateToBilling = (topic, data) => {
        this.history.ifPresentOrElse(
            history => history.push(AppRoutes.ADVERTISEMENT_BILLING),
            () => Logger.warn("History not initialized yet.")
        );
    };

}

export default new AppNavigationActions();